import React from "react";
import { Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Suspense } from "react";
import CommonPage from "../NCLLayout";
import Participationtable from "../../InstitutionAdmin/Participation";
import PerformanceTable from "../../InstitutionAdmin/Performance/Performance";
import RegionPerformanceDrillDown from "../../InstitutionAdmin/Performance/RegionPerformanceDrillDown";
import StatePerformanceDrillDown from "../../InstitutionAdmin/Performance/StatePerformanceDrillDown";
import DistrictPerformanceDrillDown from "../../InstitutionAdmin/Performance/DistrictPerformanceDrillDown";
import HQStudentwiseR from "../../InstitutionAdmin/Performance/HQSWResults";
import HQLoPerformanceReport from "../../InstitutionAdmin/Performance/LoPerformanceReport";
import Rmaterial from "../../QBAdmin/QuestionBank/Remediation";
import SamagraLo from "../../Student/Samagra/SamagraLo";
import HQViewAnswerSheet from "../../InstitutionAdmin/Performance/ViewAnswerSheet";
import HQSchoolPerformance from "../../InstitutionAdmin/Performance/SchoolPerformance/Dashboard/Dashboard";
import HQSDiffLevel from "../../InstitutionAdmin/Performance/SchoolPerformance/TeacherDifflevel";
import HQSPerformanceEachStudent from "../../InstitutionAdmin/Performance/SchoolPerformance/PerformanceEachStudent";

import PReportCards from "../../InstitutionAdmin/Performance/PReportCards/SSPRCard";

import AdministratoReport from "../../InstitutionAdmin/AdministratoReport/AdministratoReport";

import AssessmentsParticipation from "../../InstitutionAdmin/AssessmentsParticipation/AssessmentsParticipation";

import SamagraDashboardApp from "../../Principle/SamagraFileDashboard/src/App";
const HQAdminRoutes = (items) => {
    return (
        <>
            <Route path="/InstitutionAdmin" element={<CommonPage />}>
                <Route index element={<Participationtable />} />
                <Route path="/InstitutionAdmin/Performance" element={<PerformanceTable />} />
                <Route path="/InstitutionAdmin/Performance/RegionPerformanceDetails" element={<RegionPerformanceDrillDown />} />
                <Route path="/InstitutionAdmin/Performance/RegionPerformanceDetails/StatePerformanceDetails" element={<StatePerformanceDrillDown />} />
                <Route path="/InstitutionAdmin/Performance/RegionPerformanceDetails/StatePerformanceDetails/DistrictPerformanceDetails" element={<DistrictPerformanceDrillDown />} />
                <Route path="/InstitutionAdmin/Performance/SWResults" element={<HQStudentwiseR />} />
            </Route>

            <Route path="/Performance/LoPerformanceReport" element={!!items ? <CommonPage /> : <Navigate replace to="/login" />} >
                <Route index element={<Suspense fallback={<div>Loading...</div>}> <HQLoPerformanceReport /> </Suspense>} />
                <Route path="/Performance/LoPerformanceReport/Remediation" element={<Rmaterial />} />
            </Route>

            <Route path="/Performance/Samagra" element={!!items ? <CommonPage /> : <Navigate replace to="/login" />} >
                <Route path="LoPerformance" element={<SamagraLo />} />
            </Route>

            <Route path="/Performance/ViewAnswerSheetDetails/ViewAnswerSheet" element={!!items ? <CommonPage /> : <Navigate replace to="/login" />} >
                <Route index element={<HQViewAnswerSheet />} />
            </Route>

            <Route path="/Performance/SchoolPerformance" element={!!items ? <CommonPage /> : <Navigate replace to="/login" />} >
                <Route index element={<HQSchoolPerformance />} />
                <Route path="/Performance/SchoolPerformance/TeacherDiffLevel" element={<HQSDiffLevel />} />
                <Route path="/Performance/SchoolPerformance/PerformanceByeachSubject" element={<HQSPerformanceEachStudent />} />
            </Route>

            <Route path="/Performance/Reportcards" element={!!items ? <CommonPage /> : <Navigate replace to="/login" />} >
                <Route index element={<PReportCards />} />

            </Route>

            <Route path="/InstitutionReports" element={<CommonPage />}>
                <Route index element={<AdministratoReport />} />
            </Route>

            <Route path="/Institution/Assessments Participation" element={<CommonPage />}>
                <Route index element={<AssessmentsParticipation />} />
            </Route>

            <Route path="/SamagraDashboard" element={!!items ? <CommonPage /> : <Navigate replace to="/login" />} >
                <Route index element={<SamagraDashboardApp />} />
            </Route>
        </>
    );
}
export default HQAdminRoutes;